import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

export const DividendPredictionModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto text-sm text-bluegray-700">
          <div className="flex flex-row">
            <div className="flex-grow text-lg font-bold text-gray-800">
              予想データについて
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4 font-bold">表示される予想情報</div>
          <div className="mt-1 leading-6">
            ・国内株式が対象です。
            <br />
            ・マネーツリー連携と手入力資産は対象外です。
            <br />
            ・配当金予想は現在保有中の銘柄及び株数から算出しています。
            <br />
            ・配当金の金額・グラフの表示について企業が発表している予想配当の金額を表示しています。
            <br />
            ・企業から配当金に関する発表があった場合、最大1ヶ月程度反映が遅れることがあります。
            <br />
            ・配当金のグラフは、各銘柄の権利確定月から3ヶ月後に支払われるものとして作成しています。
            <br />
            ・銘柄によって実際の支払月が前後する場合があります。
            <br />
            ・ 配当情報は毎日1:00頃と13:00頃に更新されます。
            <br />
          </div>
          <div className="mt-4 font-bold">税引き額の計算</div>
          <div className="mt-1 leading-6">
            「税引き表示」は個人の配当金に対する税率20.315％（所得税・復興特別所得税15.315％、住民税5％）分を引いて表示します。NISAは非課税口座のため計算から除外されます。
          </div>
          <div className="mt-4 font-bold">
            分割、併合、配当修正が発生する場合
          </div>
          <div className="mt-1 leading-6">
            分割、併合、配当修正が発生する場合はデータが反映されるまでに時間がかかる場合があります。
          </div>
          <button className="mt-4 p-2 justify-center w-full" onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
